import React, {Suspense} from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter, Route, Routes, Navigate} from "react-router-dom";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";
import "assets/scss/modebar.scss";
import './i18n';
import '@fortawesome/fontawesome-free/css/all.min.css';

import Zcalc1 from "./layouts/calculators/Zcalc1";
import Zcalc2 from "./layouts/calculators/Zcalc2";
import HardFemCalc from "./layouts/calculators/HardFemCalc";
import SimpleFEMForm from "./layouts/calculators/SimpleFemCalc";
import {Loader} from "@skbkontur/react-ui";
import AlcoholCalcIndex from "./layouts/calculators/AlcoholCalcIndex";
import AlcoholCalcV1 from "./components/alcoholCalcs/AlcoholCalcv1";
import AlcoholCalcV7 from "./components/alcoholCalcs/AlcoholCalcv7";
import AlcoholCalcV3 from "./components/alcoholCalcs/AlcoholCalcv3";
import AlcoholCalcV6 from "./components/alcoholCalcs/AlcoholCalcv6";
import AlcoholDistributionCalc from "./components/alcoholCalcs/AlcoholCalcv2";

const HSVMaskApp = React.lazy(() => import('./layouts/calculators/HSVMaskApp'));
const AuthLayout = React.lazy(() => import('layouts/Auth.js'));
const AdminLayout = React.lazy(() => import('layouts/Admin.js'));


const dataDiv = document.getElementById("data");

let DATA = null
if (dataDiv.textContent)
    DATA = JSON.parse(dataDiv.textContent)
export {DATA}


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <BrowserRouter>
        <Suspense fallback={<Loader active={true} type="big"></Loader>}>
            <Routes>
                <Route path="cabinet/*" element={<AdminLayout/>}/>
                <Route path="auth/*" element={<AuthLayout/>}/>
                <Route path="cabinet" element={<Navigate to="/cabinet/index" replace/>}/>
                <Route path="calc/zcalc1" element={<Zcalc1/>}/>
                <Route path="calc/hard-fem" element={<HardFemCalc/>}/>
                <Route path="calc/simple-fem" element={<SimpleFEMForm/>}/>
                <Route path="calc/zcalc2" element={<Zcalc2/>}/>
                <Route path="gista" element={<HSVMaskApp/>}/>
                <Route path="alcohol-calcs" element={<AlcoholCalcIndex/>}/>
                <Route path="alcohol-calc-v1" element={<AlcoholCalcV1/>}/>
                <Route path="alcohol-calc-v7" element={<AlcoholCalcV7/>}/>
                <Route path="alcohol-calc-v3" element={<AlcoholCalcV3/>}/>
                <Route path="alcohol-calc-v6" element={<AlcoholCalcV6/>}/>
                 <Route path="alcohol-calc-v2" element={<AlcoholDistributionCalc/>}/>
            </Routes>
        </Suspense>
    </BrowserRouter>
);